module.exports = __webpack_public_path__ + "img/227.21922e20.jpg";